/**
 * Device detection for desktop-only features (Unity game + its Whereby call).
 *
 * User-agent based ON PURPOSE: viewport width must NOT count — a narrow desktop
 * window is still a desktop and may never be blocked. Desktop browsers never
 * carry the mobile UA tokens below, so this can only ever match phones/tablets.
 */
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false

  const userAgent = navigator.userAgent

  // Phones and tablets (Chrome/Safari/Firefox/Samsung on Android + iOS all match).
  const isMobileUserAgent = /android|iphone|ipad|ipod|windows phone|blackberry|opera mini|iemobile|mobile/i.test(
    userAgent
  )

  // iPadOS 13+ reports a Macintosh UA; multi-touch gives it away (real Macs report 0 touch points).
  const isIpadReportingAsMac = /macintosh/i.test(userAgent) && (navigator.maxTouchPoints ?? 0) > 1

  return isMobileUserAgent || isIpadReportingAsMac
}
